<template>
    <div :class="['totem-tree-select', size]">
        <Treeselect
            :options="options"
            :placeholder="placeholder"
            v-model="localSelectedCategories"
            :multiple="true"
            :flatten-search-results="false"
            valueConsistsOf="BRANCH_PRIORITY"
            v-on:input="onInputChange"
            search-nested
            valueFormat="object"
            :flat="true"
            :class="treeselectClass"
            :noResultsText="$t('TotemSelect.not_found')"
            :normalizer="normalizeNode"
        >
            <div v-if="doNotShowOptions" slot="value-label" slot-scope="{ node }">{{ $t('CourseListFilter.categories')}}</div>
            <div v-else slot="value-label" slot-scope="{ node }">{{ $t('CourseListFilter.categories')}} <span class="selected-count">{{ selectedOptions.length }}</span> </div>
            <span v-if="selectedOptions.length" class="selected-count">
                {{ selectedOptions.length }}
            </span>
        </Treeselect>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    const flattenChildren = (node, children = []) => {
        if (node.children) {
            node.children.forEach(child => {
                children.push(child)
                flattenChildren(child, children)
            })
        }
        return children
    }

    export default {
        name: 'totem-tree-select',
        components: {
            Treeselect
        },
        props: {
            options: {
                type: Array,
                default: () => []
            },
            placeholder: String,
            value: [ String, Object ],
            size: {
                type: String,
                validator: (prop) => [ 'small', 'large' ].includes(prop)
            },
            icon: String,
            selectedOptions: Array,
            doNotShowOptions: {
                type: Boolean,
                default: false
            },
            disableBranchNodes: {
                type: Boolean,
            }
        },
        data () {
            return {
                content: this.value,
                localSelectedCategories: null
            }
        },
        computed: {
            flattenedOptions () {
                return this.options.reduce((acc, option) => {
                    acc.push(option)
                    acc = [...acc, ...flattenChildren(option)]
                    return acc
                }, [])
            },
            treeselectClass () {
                return {
                    'disable-branch-nodes': this.disableBranchNodes,
                    'no-options': this.options.length === 0
                }
            },
        },
        watch: {
            options: {
                immediate: true,
                handler () {
                    this.updateLocalSelectedCategories()
                }
            },
            selectedOptions: {
                immediate: true,
                handler () {
                    this.updateLocalSelectedCategories()
                }
            }
        },
        methods: {
            normalizeNode(node) {
                return {
                    ...node,
                    label: this.htmlToText(node.label),
                }
            },
            htmlToText(html) {
                const doc = new DOMParser().parseFromString(html, 'text/html')
                return doc.body.textContent || ""
            },
            onInputChange (picked) { // basicly for clearing select from plugin...
                if (picked.length === 0) {
                    this.$emit('deselectAll')
                } else {
                    this.$emit('setFilterValues', this.localSelectedCategories)
                }
            },
            updateLocalSelectedCategories () {
                if (this.selectedOptions.length === 0 || this.flattenedOptions.length === 0) {
                    this.localSelectedCategories = null
                    return
                }
                this.localSelectedCategories = this.flattenedOptions.filter(option => {
                    return this.selectedOptions.find(selectedOption => selectedOption.value === option.id)
                })
            },
            clear () {
                this.content = null
                this.$emit('input', this.content)
            },
            clearWithoutEmit () {
                this.content = null
            }
        }
    }
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";

.totem-tree-select {
    @include tree-select;

    .disable-branch-nodes {
        .vue-treeselect__indent-level-0 > .vue-treeselect__option {
            .vue-treeselect__checkbox-container {
                display: none;
            }

            .vue-treeselect__label-container {
                pointer-events: none;
            }
        }
    }

    .no-options {
        cursor: not-allowed;

        .vue-treeselect__control {
            pointer-events: none;
            opacity: 0.6;
            background: $concrete;
        }
    }

    .vue-treeselect__multi-value-item {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.6rem;
        background: $white;
        color: $black;
        border: none;
        padding: 3px 0 3px 1px;
    }
}

.vue-treeselect__no-results-tip-text {
    font-size: 1.6rem;
    color: black;
    text-align: center;
    cursor: not-allowed;
    height: 10px !important;
    line-height: 18px;
}

.vue-treeselect__icon-container {
    display: none;
}

.vue-treeselect--open .vue-treeselect__control {
    border: 1px solid $lavender;
    border-radius: 15px 15px 0 0;
}

.vue-treeselect--open .vue-treeselect__menu {
    border: 1px solid $lavender;
}

.vue-treeselect__control input {
    font-size: 1.6rem;
    font-family: Nunito-Regular, sans-serif;
    width: 100% !important;
}

</style>
